import { useState } from 'react'
import Container from '../../../../elements/Container'
import MTEMeasurementConfigure from '../../_components/MTE/MTEMeasurementConfigure'
import MTEMeasurementDataPreview from '../../_components/MTE/MTEMeasurementDataPreview'
import { useNavigate, useParams } from 'react-router-dom'
import { URLS } from '../../../../_config'

type configureStateType = 'preview' | 'configure'
interface Props {
    abc?: string
}

const MTEMeasurementConfigurePage: React.FC<Props> = ({ abc }) => {
    const params: any = useParams()
    const navigate = useNavigate()

    const [state, setState] = useState<configureStateType>('preview')

    return (
        <Container size="md">
            <div className="shadow-1 rounded-[0.833rem] p-5">
                <div className="w-full">
                    {state == 'preview' && (
                        <MTEMeasurementDataPreview
                            tabledata={{}}
                            literal={params.experiment}
                            onContinue={() => {
                                setState('configure')
                            }}
                            onPrevious={() => {
                                void navigate(URLS.MEASUREMENT(params.experiment, 'filter', 'for=intervention'))
                            }}
                        />
                    )}
                    {state == 'configure' && (
                        <MTEMeasurementConfigure
                            tabledata={{}}
                            literal={params.experiment}
                            onContinue={() => {}}
                            onPrevious={() => {
                                setState('preview')
                            }}
                        />
                    )}
                </div>
            </div>
        </Container>
    )
}

export default MTEMeasurementConfigurePage
